const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");

export type CarryoverAvailability = { personId: string; fromMinutes: number; category: string };
export type CarryoverTrip = { vehicleId: string; driverPersonId: string; passengerPersonIds: string[]; baseId: string; departAtMinutes: number; arriveAtMinutes: number; reason: string };
export type RoundCarryover = { sourceRound: string; resumeAtMinutes: number | null; note: string; availability: CarryoverAvailability[]; preDispatched: CarryoverTrip[]; updatedAt?: string };

async function call<T>(method: string, tournamentId: string, round: string, body?: unknown): Promise<T> {
  const response = await fetch(`${API_BASE}/tournaments/${encodeURIComponent(tournamentId)}/rounds/${round}/carryover`, {
    method,
    credentials: "include",
    headers: { Accept: "application/json", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = json?.detail;
    throw new Error(typeof detail === "string" ? detail : detail?.message || `HTTP ${response.status}`);
  }
  return json as T;
}

export const carryoverApi = {
  get: (tournamentId: string, round: string) => call<{ carryover: Partial<RoundCarryover> }>("GET", tournamentId, round),
  save: (tournamentId: string, round: string, payload: Omit<RoundCarryover, "updatedAt">) => call<{ carryover: RoundCarryover }>("PUT", tournamentId, round, payload),
  remove: (tournamentId: string, round: string) => call<{ ok: boolean }>("DELETE", tournamentId, round),
};
